import React from "react";
import { css } from "@emotion/react";

import { colors } from "../assets/styles/variables";

const actionBox = css`
  box-sizing: border-box;
  max-width: 300px;
  min-width: 260px;
  width: 100%;
  margin: 2px auto 0;
  padding: 20px;
  text-align: center;
  background-color: ${colors.gray};

  &:first-of-type {
    margin-top: 0;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
    color: ${colors.white};

    img {
      display: inline-block;
      margin-right: 10px;
    }
  }
`;

interface Props {
  title: string;
  icon: any;
  iconWidth: number;
  iconHeight: number;
  children: any;
}

const ActionBox = (props: Props) => {
  const { title, icon, iconWidth, iconHeight, children } = props;

  return (
    <section css={actionBox}>
      <div className="title">
        <img src={icon} width={iconWidth} height={iconHeight} alt="" />
        <h2>{title}</h2>
      </div>
      {children}
    </section>
  );
};

export default ActionBox;
